import React from 'react';
import styled from 'styled-components';
import { device } from 'themes/media-queries';
import { Link } from 'components';
import { ROUTES } from 'navigation/route-map';

const YepstrLogo = props => {
  const { className } = props;
  return <Logo className={className} to={ROUTES.HOME} >yepstr</Logo>;
};

const Logo = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  background-image: linear-gradient(225deg, #f59b24, #eb730b);
  box-shadow: 0 0 25px 0 rgba(43, 44, 61, 0.2);
  width: 8rem;
  height: 8rem;
  text-decoration: none;

  font-size: 2rem;
  font-weight: 700;
  color: white;

  @media ${device.mobileL} {
    width: 6rem;
    height: 6rem;
    font-size: 1.5rem;
  }
`;

export default YepstrLogo;
